// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"366526b04f4fcd996ae2","655":"5423dd2a0a091ee33e19"}[chunkId] + ".js";
};